// KFT-3922 prices in cents — must match cartGetters.getGiftcardAddonList's
// CARD/BOX prices (2,95 €/6,95 €), since that's what actually gets charged
// once the cart line reaches checkout. Keep the two in sync if either changes.
export const GIFTCARD_PERSONALIZATION_ADDON_PRICE_CENTS = {
  PDF: 0,
  GREETING_CARD: 295,
  GIFT_BOX: 695,
}
